module.exports = __webpack_public_path__ + "media/images/mission_icon_4-eae9603fa20cb398243524023c4b9836.svg";